<template>
  <div
    class="debug-tile"
    v-bind:class="{ bottom, top, left, right }"
    v-bind:style="{ color, borderColor: color }"
  >
    {{ data }}
  </div>
</template>

<script>
export default {
  name: 'DebugTile',

  props: {
    data: Object,

    color: {
      type: String,
      default: 'red',
    },

    bottom: { type: Boolean, default: false },
    top: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.debug-tile {
  font-family: 'Arial';
  font-size: 2rem;

  opacity: 0.8;

  position: absolute;
  z-index: 10000;

  max-width: 60rem;
  padding: 1rem;

  border-width: 1px;
  border-style: solid;

  background-color: rgba(0, 0, 0, 0.8);

  &.bottom { bottom: 0; }
  &.top    { top: 0; }
  &.left   { left: 0; }
  &.right  { right: 0; }
}
</style>
